export default __webpack_public_path__ + "static/media/testify15.32a07e3c.png";